import type { LegacyPaymentOption, PaymentOption } from '@niarab2c/frontend-commons/src/types/hotels';
import React from 'react';
import { useTheme } from '../../..';
import { PaymentConditions } from '../../../HotelDetails';
import Price from '../../Price';
import * as S from './styles';
type CartTotal = {
  value: number;
  currency: string;
  taxes: number;
};
export type CartTotalProps = {
  cartTotal: CartTotal;
  paymentOptions?: LegacyPaymentOption[] | PaymentOption[];
  onCheckout: () => void;
  onCreateQuotation?: () => void;
  onGoToCart?: () => void;
  hideSeeCartButton?: boolean;
};
const CartTotal: React.FC<CartTotalProps> = ({
  cartTotal,
  paymentOptions,
  onCheckout,
  onCreateQuotation,
  onGoToCart,
  hideSeeCartButton
}) => {
  const theme = useTheme();
  const emptyCart = Object.keys(cartTotal).length === 0;
  return <S.Content>
      {cartTotal && <S.Info>
          <S.Total>
            <h5>Total</h5>
            <S.ContainerPriceInTotal>
              <Price value={cartTotal?.value} currency={cartTotal?.currency} currencyFontWeight="normal" priceCoinFontWeight="bold" fractionFontWeight="bold" currencySize={13} priceCoinSize={20} decimalSize={13} fractionSize={13} color={theme.colors?.priceColor} dataTestId="cart-total-price" />
            </S.ContainerPriceInTotal>
          </S.Total>
          <S.Taxes>Inclui impostos e taxas</S.Taxes>
          <S.Conditions>
            {paymentOptions && <PaymentConditions justifyContent="flex-end" paymentOptions={paymentOptions} textSize={12} fontWeight={400} showStartIcon ellipsis />}
          </S.Conditions>
        </S.Info>}

      <S.ActionButtonsContainer>
        {hideSeeCartButton ? null : onGoToCart && <S.Button color="textColor" variant="outlined" onClick={onGoToCart} data-testid="cart-button-add-to-cart">
                <strong>Ver carrinho</strong>
              </S.Button>}

        {onCheckout && <S.Button color="success" variant="contained" disabled={emptyCart} onClick={onCheckout} data-testid="cart-button-reservation">
            Reservar Agora
          </S.Button>}

        {onCreateQuotation && <S.Link as="button" onClick={onCreateQuotation}>
            Gerar cotação
          </S.Link>}
      </S.ActionButtonsContainer>
    </S.Content>;
};
export default CartTotal;